import { defineComponent as p, inject as e, ref as o, openBlock as r, createElementBlock as c, normalizeClass as u, renderSlot as m } from "vue";
const b = /* @__PURE__ */ p({
  __name: "IstMainContent",
  props: {
    mobilMenu: {
      type: Boolean,
      default: !1
    }
  },
  setup(n) {
    const s = e("mobile", n.mobilMenu), t = o(s), l = e("showMenu", !1), a = o(l);
    return (i, f) => (r(), c("div", {
      id: "content",
      class: u({ mobile: t.value, showMenu: a.value })
    }, [
      m(i.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
export {
  b as default
};
